///<amd-module name="Core/Medius.Core.Web/Scripts/Medius/components/presenters/link/entity/defaults"/>

export function get(){
    return {
        template: "presenters-entity-link-default",
        templateRead: "presenters-entity-link-read",
        isClickable: (true as any)
    };
}